"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useVideoElementDatadogMetrics = require("./useVideoElementDatadogMetrics");
Object.keys(_useVideoElementDatadogMetrics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useVideoElementDatadogMetrics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useVideoElementDatadogMetrics[key];
    }
  });
});